export default __webpack_public_path__ + "static/media/body-beige.b01001ef.png";